import { createContext, useContext } from 'react';

type SidebarPresentationContextValue = {
  closeDrawer: () => void;
  isCompact: boolean;
};

const noop = () => undefined;

const SidebarPresentationContext = createContext<SidebarPresentationContextValue>({
  closeDrawer: noop,
  isCompact: false,
});

type SidebarPresentationProviderProps = {
  children: React.ReactNode;
  closeDrawer?: () => void;
  isCompact: boolean;
};

export const SidebarPresentationProvider = ({
  children,
  closeDrawer = noop,
  isCompact,
}: SidebarPresentationProviderProps) => {
  return (
    <SidebarPresentationContext.Provider value={{ closeDrawer, isCompact }}>
      {children}
    </SidebarPresentationContext.Provider>
  );
};

export const useSidebarPresentation = () => useContext(SidebarPresentationContext);
